import { LazyMapsAPILoaderConfigLiteral } from "@agm/core";
import { Injectable } from "@angular/core";
import { DMVStoreService } from "../dmv/dmv-store.service";
import { AppUtil } from "./../../utils/app.util";

@Injectable({ providedIn: "root" })
export class GoogleMapsConfig implements LazyMapsAPILoaderConfigLiteral {
	public apiKey: string;
	constructor(private dmvStoreService: DMVStoreService) {
		AppUtil.log("INSIDE MAPs"); //This is not displayed in console
		dmvStoreService.agencyConfigData$.subscribe(agencyConfigData => {
			if (
				agencyConfigData &&
				agencyConfigData.agencyDmvConfig &&
				agencyConfigData.agencyDmvConfig.mapAPIKey
			) {
				AppUtil.log(
					"agencyConfigData.agencyDmvConfig.mapAPIKey :" +
						agencyConfigData.agencyDmvConfig.mapAPIKey
				);
				this.apiKey = agencyConfigData.agencyDmvConfig.mapAPIKey;
			}
		});
	}
}
